import ReservationService from "Services/reservation.service";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

const getAlternateSearchValue = () => {
  const value = sessionStorage.read(ReservationService.ALTERNATE_SEARCH_RESORT);
  if (value === null) {
    return false;
  }
  console.log("isAlternateSearchAvailable::", value, value === "true");
  return value === "true";
};

export { getAlternateSearchValue };
